import { FC } from 'react';
import { SwitchButton } from './Switch.styles';
import { SwitchProps } from '@sleepunique/types/switch-type';

const Switch: FC<SwitchProps> = ({ label, isActive, onClick, dark }: SwitchProps) => (
  <SwitchButton data-text={label} label={label} isActive={isActive} type="button" onClick={onClick} dark={dark}>
    {label}
  </SwitchButton>
);

export default Switch;
